import React from "react";
import { cn } from "components/ui/cn";

/**
 * Superficie base de la app.
 *
 * El peso visual lo lleva el borde de 1px, no la sombra: así las tarjetas se
 * apoyan sobre el fondo en lugar de flotar. El hover elevado dejó de ser
 * automático — sólo lo reciben las tarjetas que de verdad son clickeables
 * (`interactive`), para que el movimiento signifique algo.
 */
function Card(props: {
  variant?: string;
  extra?: string;
  interactive?: boolean;
  children?: JSX.Element | any[];
  [x: string]: any;
}) {
  const { variant, extra, interactive = false, children, ...rest } = props;
  return (
    <div
      className={cn(
        "relative flex flex-col rounded-card border border-gray-200/80 bg-white bg-clip-border",
        "shadow-card transition-[box-shadow,transform,border-color] duration-200 ease-premium",
        "dark:border-white/10 dark:!bg-navy-800 dark:text-white dark:shadow-none",
        interactive &&
          "hover:-translate-y-[2px] hover:border-gray-300 hover:shadow-card-hover dark:hover:border-white/20",
        extra
      )}
      {...rest}
    >
      {children}
    </div>
  );
}

export default Card;
